export default function BudgetProgressBar({ spent, amount }: { spent: number; amount: number }) {
  const pct = amount > 0 ? (spent / amount) * 100 : 0;
  const width = Math.min(100, Math.max(0, pct));
  const tone = pct > 100 ? "over" : pct >= 80 ? "warn" : "normal";
  return (
    <div className={`budget-bar ${tone}`}>
      <div className="budget-bar-track">
        <div className="budget-bar-fill" style={{ width: `${width}%` }} />
      </div>
    </div>
  );
}
